'use strict';

import _default from './modules/default';

$(function () {
    _default.init();
});